import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";

/* ────────── tipo mínimo que usa la UI ────────── */
export interface TipoAsignatura {
  id: number;
  codigo: string; // 'A' | 'B' | …
  nombre: string; // alias para comodidad
  descripcion: string;
}

/**
 * Devuelve el catálogo completo de tipos de asignatura
 *   GET /tipos-asignatura → [{ id, codigo, descripcion }]
 */
export function useTipos() {
  const { data = [], isFetching: loading } = useQuery({
    queryKey: ["tipos-asignatura"],
    queryFn: async () => {
      const { data } = await api.get("/tipos-asignatura");

      // Mapeamos y mostramos los datos para ver si contienen el ID correcto
      const tiposMapped = (data ?? [])
        .map((t: any) => {
          if (!t.id) {
            return null; // Excluir tipos sin ID
          }
          const tipo = {
            id: t.id,
            codigo: t.codigo,
            descripcion: t.descripcion,
            nombre: `${t.codigo} – ${t.descripcion}`, // ← para Autocomplete
          };
          return tipo;
        })
        .filter(Boolean) as TipoAsignatura[];

      return tiposMapped;
    },
  });

  return { rows: data, loading };
}
